/* eslint-disable import/first */
import React, { useImperativeHandle, forwardRef } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import { useIntl } from 'react-intl';
const { clearCart, sendCart } = Slices.cartSlice;
const { postReOrder } = Slices.orderSlice;

import css from './index.module.scss';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

const ReOrder = forwardRef(({ orderId }, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const [open, setOpen] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState('');
  const addCart = async () => {
    dispatch(clearCart());
    try {
      const res = await dispatch(postReOrder({ orderId }));
      // SEND LOCAL CART
      // Check if there is an error in the response
      if (res.error) {
        setOpen(true);
        setErrMsg(res.error.message);
        // Perform additional steps or handle the error as needed
      } else {
        dispatch(sendCart.fulfilled(res?.payload));
        navigate(`/${intl.locale}/cart`);
      }
    } catch (error) {
      // Handle any network or server errors
      console.error('An error occurred:', error);
    }
  };

  useImperativeHandle(ref, () => ({
    addCart() {
      addCart();
    },
  }));

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  return (
    <div className={css.root}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </div>
  );
});

export default ReOrder;
